import axios from "axios";
import { BASE_URL, OCP_APIM_SUBSCRIPTION_KEY, emailEncryptKey } from "../constants/constant";
import CryptoJS from "crypto-js";
export class Service {
  getHeader(token) {
    return {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": OCP_APIM_SUBSCRIPTION_KEY,
      Authorization: "Bearer  " + token,
      "Access-Control-Allow-Origin": "*",
    };
  }

  getLoginHeader(token, useremail) {
    return {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": OCP_APIM_SUBSCRIPTION_KEY,
      Authorization: "Bearer  " + token,
      "Access-Control-Allow-Origin": "*",
      "X-User-Email": useremail
    };
  }

  newGetApi(url, params, token, signal) {
    return axios.get(BASE_URL + url, {
      params: params,
      headers: this.getHeader(token),
      signal: signal,
    });
  }

  newPostApi(url, params, token) {
    return axios.post(BASE_URL + url, params, {
      headers: this.getHeader(token),
    });
  }

  newPutApi(url, params, token) {
    return axios.put(BASE_URL + url, params, {
      headers: this.getHeader(token),
    });
  }

  newDeleteApi(url, params, token) {
    return axios.delete(BASE_URL + url, {
      params: params,
      headers: this.getHeader(token),
    });
  }

  testGetApi(url, params, token, signal) {
    const result = axios.get(url, {
      params: params,
      headers: this.getHeader(token),
      signal: signal,
    });
    return result;
  }

  testGetLoginApi(url, params, token, signal) {
    const keyUtf8 = CryptoJS.enc.Utf8.parse(emailEncryptKey);
    const encrypted = CryptoJS.AES.encrypt(params.email, keyUtf8, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    const encrypted_email = encrypted.toString();
    const result = axios.get(url, {
      params: {email: encrypted_email},
      headers: this.getHeader(token, params.email),
      signal: signal,
    });
    return result;
  }

  testPutApi(url, params, token) {
    const result = axios.put(url, params, { headers: this.getHeader(token) });
    return result;
  }

  testPostApi(url, params, token) {
    const result = axios.post(url, params, { headers: this.getHeader(token) });
    return result;
  }

  testDeleteApi(url, params, token) {
    const result = axios.delete(url, {
      params: params,
      headers: this.getHeader(token),
    });
    return result;
  }
}

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    if (
      response["config"]["method"] === "post" ||
      response["config"]["method"] === "put" ||
      response["config"]["method"] === "delete"
    ) {
      console.log("Response Console", response?.status == "302", response);

      //   if (response?.status == "302") {
      //     console.log("Need to login.");
      //     window.location.href =
      //       "#";
      //   }
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
